<section class="section-inset-y">
  <div class="container">
    <h3>Palettes</h3>

    <ul class="section-outset-b row">
      @for (palette of (themes$ | async)?.reverse(); track palette) {
        <li class="mb-3 col-md-6">
          <h2 class="h4">#{{ palette.id }} {{ palette.name }}</h2>
          <div class="d-flex">
            <app-palette-card class="d-block me-3" [palette]="palette"></app-palette-card>
            <table class="color-table" [ngClass]="palette.name">
              <thead>
                <tr>
                  <th class="fw-bold">Name</th>
                  <th class="fw-bold">Value</th>
                  <th class="fw-bold">Color</th>
                </tr>
              </thead>
              @for (
                key of [
                'primary',
                'primaryText',
                'background',
                'backgroundLight',
                'backgroundDark',
                'backgroundTextColor',
                'backgroundTextInvertedColor',
                'mutedLight'
                ]
                ; track
                key) {
                <tr
                  >
                  <td>{{ key }}</td>
                  <td>{{ getColorByKey(palette, key) || 'Niet gevuld' }}</td>
                  <td>
                    <div class="swatch mb-0" [ngClass]="'bg-' + camelToDashed(key)" [style.background]="getColorByKey(palette, key)"></div>
                  </td>
                </tr>
              }
            </table>
          </div>
        </li>
      }
    </ul>

    <!-- primary: theme-color(primary),
    primary-text: white,
    muted-light: theme-color(primary),
    background: map-get($warm-grays, 100),
    background-light: map-get($warm-grays, 100),
    background-text-color: black, -->

    <h3>Palette Overview</h3>

    <ul class="row section-outset-b">
      @for (palette of themes$ | async; track palette) {
        <li class="col-sm-4 col-lg-3 mb-4">
          <article class="palette-card" [ngClass]="palette?.name">
            <figure class="palette-card__colors">
              <div class="bg-primary text-center d-block">
                <h1 class="h2 text-primary-text mb-0">Aa</h1>
                <span class="text-muted-light">muted-light text</span>
              </div>
              <div class="bg-background text-center d-block">
                <h1 class="h2 text-background-text-color mb-2">Aa</h1>
                <button class="button button-outline button--theme-overlay">Knop</button>
              </div>
              <div class="bg-background-light">
                <h1 class="h2 text-dark mb-0">Aa</h1>
              </div>
              <!-- <div class="bg-tertiary fw-bold">accent</div> -->
              <figcaption class="palette-card__meta">
                <strong>{{ palette?.name }}</strong>
                <br />
                <span class="text-muted-light">muted-light text</span>
                <br />
                <button class="button button--primary me-2 mt-3">Knop 1</button>
                <button class="button button--secondary mt-3">Knop 2</button>
              </figcaption>
            </figure>
          </article>
        </li>
      }
    </ul>

    <h3>Overige kleuren</h3>
    @if (colors.length > 0) {
      <app-color-list type="color" title="basiskleuren" [colorList]="colors"></app-color-list>
    }
    @if (remainingColors(grayColors, activeGrayColors).length > 0) {
      <app-color-list
        title="Grijstinten"
        type="gray"
        [colorList]="remainingColors(grayColors, activeGrayColors)"
      ></app-color-list>
    }
    @if (themeColors.length > 0) {
      <app-color-list type="theme" title="Active theme colors" [colorList]="themeColors"></app-color-list>
    }
  </div>
</section>
